<div class="container">
  <img src="../../../../assets/img/trader_logo_aprovado.png" alt="Logo do Itaú Trader" aria-hidden="true">
  <span>Página não encontrada</span>
  <ids-icon size="L">fechar</ids-icon>
</div>
